module.exports = {
    "collectionLabel": `F\xf6rslag`
};


//# sourceMappingURL=sv-SE.main.js.map
